import {
    Box,
    ClickAwayListener,
    Paper,
    Popper,
    Typography,
} from "@mui/material";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { PickerSelectionState } from "@mui/x-date-pickers/internals";
import * as moment from "moment";
import React from "react";

const getLanguageLocale = (culture: string) => {
    switch (culture) {
    case "fi":
        return "fi";
    case "en":
    case "en-US":
        return "en";
    case "sv":
        return "se";
    }
};

interface CalendarDatePickerProps {
  title?: string;
  referenceDate?: Date;
  onChange: (value: any) => void;
}

export const CalendarDatePicker = (props: CalendarDatePickerProps) => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLElement>(null);

    const handleClick = () => {
        setOpen((old) => !old);
    };

    const handleClose = (event: Event | React.SyntheticEvent) => {
        if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
            return;
        }

        setOpen(false);
    };

    const handleChange = (value: any, selectionState: PickerSelectionState) => {
        if (selectionState === "finish") {
            setOpen(false);
            props.onChange(value);
        }
    };

    return (
        <>
            <Box
                onClick={handleClick}
                ref={anchorRef}
                sx={{
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                }}
            >
                <Typography
                    sx={{
                        margin: "0 1rem",
                        fontWeight: 600,
                        minWidth: "116px",
                        textAlign: "center",
                    }}
                >
                    {props.title}
                </Typography>
            </Box>
            <ClickAwayListener onClickAway={handleClose}>
                <Popper
                    id="calendar-date-picker"
                    open={open}
                    anchorEl={anchorRef.current}
                    sx={{ zIndex: 99 }}
                    placement="bottom-start"
                >
                    <LocalizationProvider
                        dateAdapter={AdapterMoment}
                        adapterLocale={getLanguageLocale(appConfig.culture)}
                    >
                        <Paper elevation={6}>
                            <DateCalendar
                                referenceDate={moment.default(props.referenceDate)}
                                onChange={handleChange}
                            />
                        </Paper>
                    </LocalizationProvider>
                </Popper>
            </ClickAwayListener>
        </>
    );
};
